var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingSpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-palette-ring",
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(65.8368 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 50 A30 30 0 0 1 59.270509831248425 78.53169548885461",
    fill: "none",
    stroke: "#51CACC",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.270509831248425 78.53169548885461 A30 30 0 0 1 25.72949016875158 67.6335575687742",
    fill: "none",
    stroke: "#9DF871",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.72949016875158 67.6335575687742 A30 30 0 0 1 25.729490168751575 32.366442431225806",
    fill: "none",
    stroke: "#E0FF77",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.729490168751575 32.366442431225806 A30 30 0 0 1 59.27050983124842 21.46830451114539",
    fill: "none",
    stroke: "#DE9DD6",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.27050983124842 21.46830451114539 A30 30 0 0 1 80 49.99999999999999",
    fill: "none",
    stroke: "#FF708E",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 50 50;360 50 50",
    times: "0;1",
    dur: 1,
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpin);
export default __webpack_public_path__ + "static/media/loading-spin.8bd3977f2ded0784ed103c3849b85d38.svg";
export { ForwardRef as ReactComponent };